import { Stack } from "@mui/material";
import { NotificationResource } from "models/Resources/NotificationResource";
import NotificationListSection from "./NotificationListSection";
import { useEffect, useMemo, useState } from "react";
import { isNotificationExpired } from "utils/isNotificationExpired";
import { useAppDispatch } from "hooks/StoreHooks";
import { setNotificationList } from "store/Slices/gridEventSlice";
import { NotificationType } from "constants/NotificationConstants";

type Props = {
  notifications: NotificationResource[];
  isAnchored: boolean;
  handleNotificationClick: (
    type: NotificationType,
    notificationId: string
  ) => void;
};

const EXPIRY_CHECK_INTERVAL = 60000;
const READ_NOTIFICATION_LIST_TITLE = "Lues";
const NON_READ_NOTIFICATION_LIST_TITLE = "Non lues";

const NotificationList: React.FC<Props> = ({
  notifications,
  isAnchored,
  handleNotificationClick,
}: Props) => {
  const [tick, setTick] = useState(0);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const id = setInterval(() => setTick(t => t + 1), EXPIRY_CHECK_INTERVAL);
    return () => clearInterval(id);
  }, []);

  const { readNotifications, nonReadNotifications } = useMemo(() => {
    const now = Date.now();
    const notExpired = notifications.filter(
      n => !isNotificationExpired(n, now)
    );
    if (notExpired.length != notifications.length) {
      dispatch(setNotificationList(notExpired));
    }
    const read: NotificationResource[] = [];
    const nonRead: NotificationResource[] = [];
    for (const n of notExpired) (n.archivedDate ? read : nonRead).push(n);
    return { readNotifications: read, nonReadNotifications: nonRead };
  }, [notifications, tick, dispatch]);

  return (
    <Stack
      className={`notification-list${isAnchored ? " anchored" : ""}`}
      sx={{
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
      }}>
      <NotificationListSection
        title={NON_READ_NOTIFICATION_LIST_TITLE}
        notifications={nonReadNotifications}
        handleNotificationClick={handleNotificationClick}
      />
      <NotificationListSection
        title={READ_NOTIFICATION_LIST_TITLE}
        notifications={readNotifications}
        handleNotificationClick={handleNotificationClick}
      />
    </Stack>
  );
};
export default NotificationList;
